import * as actions from '_shared/actions';
import ConfigParser from '../config-parser';
import configObj from '../../../config';

const parser = new ConfigParser(configObj);

let store;
export const injectStore = (newStore) => {
  store = newStore;
};

const getAction = (actionName) => {
  const actionType = actionName;
  return actions[actionType];
};

const getNext = (currentActionName, response, state) => {
  return parser.getNextNode(currentActionName, response, state);
};

const runActions = (actionName, actionParams) => {
  let action = getAction(actionName);
  return store.dispatch(action.apply(null, actionParams)).then((response) => {
    const next = getNext(actionName, response, store.getState());
    if (next.action) {
      return runActions(next.action);
    } else {
      return next.view;
    }
  });
};

export default runActions;



/** WEBPACK FOOTER **
 ** ./src/_shared/lib/action-runner/index.js
 **/